import { useEffect, useRef } from 'react';
/**
 * This hook offers to run `callback` only one-time, when the criteria is met.
 *
 * This should be convenient to run a task on component mount, but have to wait
 * for an async query result to resolve.
 *
 * @example
 * ```js
 * useEffectOnce(
 *   () => {
 *     navigateToCategoryPage(data.categories[0].uuid);
 *   },
 *   { when: !loading && data.categories }
 * );
 * ```
 */
export default function useEffectOnce(callback, options) {
  const isDoneRef = useRef(false);
  useEffect(() => {
    if (!isDoneRef.current && options.when) {
      isDoneRef.current = true;
      return callback();
    }
  }, [callback, options.when]);
}